import FacetRefinement from './FacetRefinement'
import StaticFacetRefinement, {
  StaticItemRefinementList
} from './StaticFacetRefinement'
export type { StaticItemRefinementList }
export { StaticFacetRefinement }
export default FacetRefinement
